import { Reveal, Chapter } from "@/components/site/Reveal";
import { FLOW_STEPS } from "@/data/content";

export default function Flow() {
  return (
    <section id="flow" className="relative bg-ink">
      <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
        <Chapter n="Chapter 04" label="Project Financial Flow" dark />
        <Reveal>
          <h2 className="max-w-3xl text-balance font-serif text-3xl font-medium leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            Every rupee, mapped from greenlight to rebate.
          </h2>
        </Reveal>

        <div data-testid="flow-diagram" className="relative mt-20">
          <div className="absolute left-[27px] top-0 h-full w-px bg-white/10 lg:left-0 lg:top-[27px] lg:h-px lg:w-full" aria-hidden="true" />
          <div className="grid gap-12 lg:grid-cols-5 lg:gap-6">
            {FLOW_STEPS.map((s, i) => (
              <Reveal key={s.n} delay={0.12 * i}>
                <div
                  data-testid={["flow-step-greenlight", "flow-step-preprod", "flow-step-prod", "flow-step-post", "flow-step-audit"][i]}
                  className="group relative flex gap-6 lg:flex-col lg:gap-0"
                >
                  <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center border border-gold/40 bg-ink font-mono text-xs tracking-[0.15em] text-gold transition-all duration-500 group-hover:border-gold group-hover:bg-gold group-hover:text-ink group-hover:shadow-[0_0_36px_rgba(197,160,89,0.35)]">
                    {s.n}
                  </div>
                  <div className="lg:mt-8">
                    <h3 className="font-serif text-xl font-medium text-ivory transition-colors group-hover:text-gold">{s.title}</h3>
                    <p className="mt-2 font-mono text-[10px] uppercase leading-relaxed tracking-[0.16em] text-mist">{s.caption}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
